import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';
import { BODY, HEADLINE } from 'styles/helpers/typography';
import { installStepsStyles } from 'components/install-app-tuto/InstallSteps.styled';

const TutoComputerWrapper = styled.div`
  padding-bottom: ${prem(20)};

  ${installStepsStyles}

  .steps {
    flex-flow: row wrap;
    align-items: stretch;
    max-width: ${prem(900)};
  }

  .step {
    flex: 1 1 ${prem(280)};
    max-width: ${prem(520)};
  }

  .step-title {
    ${HEADLINE.small}
    margin-bottom: ${prem(6)};
  }

  .qr-codes {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${prem(24)};
    margin-top: auto;
  }

  .qr-code-wrapper {
    width: ${prem(140)};
    margin: 0;

    figcaption {
      ${BODY.medium}
      margin-top: ${prem(8)};
      font-weight: bold;
      line-height: 1.3;
    }
  }

  .qr-code {
    display: block;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: ${prem(6)};
    border-radius: ${prem(8)};
    background: white;
  }

  .qr-code-placeholder {
    aspect-ratio: 1;
    opacity: 0.5;
  }

  .ready {
    ${BODY.medium}
    max-width: ${prem(600)};
    margin: ${prem(20)} auto 0;
    color: var(--ion-text-color-secondary);
  }
`;

export { TutoComputerWrapper };
